const { DEFAULT_LOCALE, ACCEPTED_LOCALES } = require('./src/constants/locales.cjs');
const path = require('path');

const LocizeBackend = require('i18next-locize-backend/cjs');
const ChainedBackend = require('i18next-chained-backend/dist/cjs/i18nextChainedBackend');
const HttpBackend = require('i18next-http-backend/cjs');

const isBrowser = typeof window !== 'undefined';

const tenant = process.env.NEXT_PUBLIC_TENANT;

const LOCIZE_PROJECT_IDS = {
  mobiworkx: process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID_MOBIWORKX,
  qmee: process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID_QMEE,
};

const LOCIZE_SECRETS = {
  mobiworkx: process.env.NEXT_PUBLIC_LOCIZE_SECRET_MOBIWORKX,
  qmee: process.env.NEXT_PUBLIC_LOCIZE_SECRET_QMEE,
};

const locizeProjectId = LOCIZE_PROJECT_IDS[tenant] ?? process.env.NEXT_PUBLIC_LOCIZE_PROJECT_ID;
const locizeSecret = LOCIZE_SECRETS[tenant] ?? process.env.NEXT_PUBLIC_LOCIZE_SECRET;

const useLocize =
  isBrowser &&
  process.env.NODE_ENV !== 'production' &&
  Boolean(locizeProjectId) &&
  process.env.NEXT_PUBLIC_SAVE_MISSING_TRANSLATIONS === 'true';

// Define which tenants require a subfolder
const customLocales = ['qmee', 'mobiworkx', 'lifepoints'];
const localeSubPath = customLocales.includes(tenant) ? `/${tenant}` : '';

const settings = {
  debug: process.env.NEXT_PUBLIC_SAVE_MISSING_TRANSLATIONS === 'true' && useLocize,
  cleanCode: true,
  backend: {
    backends: useLocize ? [LocizeBackend, HttpBackend] : [],
    backendOptions: [
      {
        projectId: locizeProjectId,
        apiKey: locizeSecret,
        version: 'latest',
        reloadInterval: false,
      },
      {
        loadPath: `/locales${localeSubPath}/{{lng}}/{{ns}}.json`,
      },
    ],
  },
  serializeConfig: false,
  lowerCaseLng: true,
  use: useLocize ? [ChainedBackend] : [],
  saveMissing: process.env.NEXT_PUBLIC_SAVE_MISSING_TRANSLATIONS === 'true' && useLocize, // set to the useLocize constant (above) if you want to upload missing translations
  nsSeparator: false, // allow keys to be phrases having `:`, `.`
  keySeparator: false, // allow keys to be phrases having `:`, `.`
  fallbackLng: DEFAULT_LOCALE, // Without this the automated translation collection doesn't work
};

const localePath = customLocales.includes(tenant)
  ? path.resolve(`./public/locales/${tenant}`)
  : path.resolve('./public/locales');

/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    locales: ['default', ...ACCEPTED_LOCALES],
    /**
     * Prevent Next.js from removing the default locale when normalizing the URL by giving it a fake one.
     */
    defaultLocale: 'default',
    localeDetection: false, // we reimplement this in middleware as Next only redirects on request to the root.
  },
  ...settings,
  localePath,
};
